import React from 'react'
import { Button, Paper, Box, TextField, Typography } from '@mui/material'
import { Field, ErrorMessage } from 'formik'


function EditNamePopupFormik({handleCancel, errors, touched, title}) {
    return (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            {/* Overlay. TODO: Make sure interaction with rest of screen not possible while overlay is open */}
            <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)', position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none' }} onClick={handleCancel}></div>
            {/* Popup */}
            <Paper style={{  zIndex: 1000 }}>
            <div style={{ padding: '15px', minWidth: '250px' }}>
                <Typography variant='h6' sx={{fontWeight: 'Regular'}}>{title}</Typography>
                <Field 
                    as={TextField}
                    id='name'
                    name='name'
                    sx={{width: '100%', marginTop: '20px'}} 
                    label="Name"
                    variant="filled" 
                    required
                    error={errors.name && touched.name}
                />
                <ErrorMessage name="name" component="div" style={{ color: 'red' }} />
                <Box sx={{display: 'flex', marginTop: '15px', justifyContent: 'space-between'}}>
                    <Button onClick={handleCancel} variant="outlined">Cancel</Button>

                    {/* TODO: set/update the color only if the save button is clicked */}
                    <Button sx={{minWidth: '85px'}} type='submit' variant="contained" color="primary">Save</Button>
                </Box>
            </div>
            </Paper>
        </div>
    )
}

export default EditNamePopupFormik